import featureCardIcon1 from "../images/features/time.svg";
import featureCardIcon2 from "../images/features/analytics.svg";
import featureCardIcon3 from "../images/features/blockchain.svg";
import featureCardIcon4 from "../images/features/dashboard.svg";
import featureCardIcon5 from "../images/features/safe.svg";
import featureCardIcon6 from "../images/features/Instant.svg";


const data = [
  {
    icon: featureCardIcon1,
    title: "Real Time Update",
    text: "It is a long established fact that a reader will be distracted by the readable content.",
  },
  {
    icon: featureCardIcon2,
    title: "Advanced Analytics",
    text: "It is a long established fact that a reader will be distracted by the readable content.",
  },
  {
    icon: featureCardIcon3,
    title: "Blockchain Technology",
    text: "It is a long established fact that a reader will be distracted by the readable content.",
  },
  {
    icon: featureCardIcon4,
    title: "Email Notifications",
    text: "It is a long established fact that a reader will be distracted by the readable content.",
  },
  {
    icon: featureCardIcon5,
    title: "Safe and Secure",
    text: "It is a long established fact that a reader will be distracted by the readable content.",
  },
  {
    icon: featureCardIcon6,
    title: "Instant Exchange",
    text: "It is a long established fact that a reader will be distracted by the readable content.",
  },
];

export default data;
